import { useLocation, useNavigate } from "react-router-dom";
import { Cohabitant } from "../requests";
import EditCohabitantForm from './EditCohabitantForm';

const EditCohabitantPage = (props) => {

  // console.log(props);

  const navigate = useNavigate()

  const location = useLocation()
  const fromCohabitantDetails = location.state

  const updateCohabitant = (id, params) => {
    Cohabitant.update(id, params).then((b) => {
      navigate(`/clients/${b.client_id}`)
    })
  }
  return (
    <>
      <div>
        <h1 className="text-center">Edit client page</h1>
        <EditCohabitantForm
          updateCohabitant={updateCohabitant}
          id={fromCohabitantDetails.fromCohabitantDetails.id}
          first_name={fromCohabitantDetails.fromCohabitantDetails.first_name}
          last_name={fromCohabitantDetails.fromCohabitantDetails.last_name}
          relation={fromCohabitantDetails.fromCohabitantDetails.relation}
          date_of_birth={fromCohabitantDetails.fromCohabitantDetails.date_of_birth}
        />
      </div>
    </>
  )
}

export default EditCohabitantPage